import facebook from 'public/icons/facebook.svg';
import instagram from 'public/icons/instagram.svg';
import linkedin from 'public/icons/linkedin.svg';
import twitter from 'public/icons/twitter.svg';

export default {facebook, instagram, linkedin, twitter};
